module.exports = __webpack_public_path__ + "img/12_life-skills.2dccc680.png";